module.exports = {
    am: 'am-et',
    ar: 'ar-sa',
    bg: 'bg-bg',
    'bn-in': 'bn-in',
    ca: 'ca-es',
    cs: 'cs-cz',
    cy: 'cy-gb',
    da: 'da-dk',
    de: 'de-de',
    el: 'el-gr',
    en: 'en-us',
    es: 'es-es',
    'es-mx': 'es-mx',
    et: 'et-ee',
    eu: 'eu-es',
    fa: 'fa-ir',
    fi: 'fi-fi',
    fil: 'fil-ph',
    fr: 'fr-fr',
    'fr-ca': 'fr-ca',
    gl: 'gl-es',
    gu: 'gu-in',
    he: 'he-il',
    hi: 'hi-in',
    hr: 'hr-hr',
    hu: 'hu-hu',
    id: 'id-id',
    is: 'is-is',
    it: 'it-it',
    ja: 'ja-jp',
    kk: 'kk-kz',
    kn: 'kn-in',
    ko: 'ko-kr',
    'lo-la': 'lo-la',
    lt: 'lt-lt',
    lv: 'lv-lv',
    ml: 'ml-in',
    mr: 'mr-in',
    ms: 'ms-my',
    nl: 'nl-nl',
    'nn-no': 'nn-no',
    no: 'nb-no',
    pl: 'pl-pl',
    pt: 'pt-br',
    'pt-pt': 'pt-pt',
    ro: 'ro-ro',
    ru: 'ru-ru',
    sk: 'sk-sk',
    sl: 'sl-si',
    sr: 'sr-latn-rs',
    'sr-cyrl': 'sr-cyrl-rs',
    sv: 'sv-se',
    sw: 'sw-ke',
    ta: 'ta-in',
    te: 'te-in',
    th: 'th-th',
    tr: 'tr-tr',
    uk: 'uk-ua',
    ur: 'ur-pk',
    vi: 'vi-vn',
    'zh-hans': 'zh-cn',
    'zh-hant': 'zh-tw',
};
